import { useParams, useNavigate, Outlet } from 'react-router-dom'
import { useAuthContext } from '@/context-state/AuthContext.jsx'
import { togglePricingPlansDialog, usePricingPlans } from '@/hooks/usePricingPlans.jsx'
import { useVerifyPayment } from '@/hooks/useVerifyPayment.jsx'
import { PricingPlansDialog } from '@/components/pricing-plans/PricingPlansDialog'
import { VerifyPayment } from '@/pages/payment/paddle/VerifyPayment'
import { useEffect } from 'react'
import { AUTH_BASE_PATH } from '@/consts/index.js'

export default function AccountDefault() {

    const { accountId } = useParams()
    const { accounts, logout } = useAuthContext()
    const navigate = useNavigate()
    const isPricingPlansDialogOpen = usePricingPlans()
    const isVerifyPaymentDialogOpen = useVerifyPayment()

    useEffect(() => {
        // If no accounts, redirect to auth
        if (!accounts?.length) {
            logout()
            return
        }

        const currentAccount = accounts.find(account => account._id === accountId);

        if (!currentAccount) {
            // If account ID doesn't exist, redirect to first account's space
            const firstAccount = accounts[0]
            navigate(`/account/${firstAccount._id}/space`)
            return
        }

        // If we're exactly at /account/:accountId, redirect to the space route
        if (window.location.pathname === `/account/${accountId}`) {
            navigate(`/account/${accountId}/space`)
        }

    }, [accounts, accountId, navigate])


    // Simplified return logic
    if (!accounts?.length) {
        return null
    }

    return (
        !accounts?.length
            ? <div />
            : (
                <div>
                    <PricingPlansDialog isOpen={isPricingPlansDialogOpen} setIsOpen={() => togglePricingPlansDialog(false)} />
                    {isVerifyPaymentDialogOpen && <VerifyPayment />}
                    <Outlet />
                </div>
            )
    )


}